<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="btn_list">
    <el-button class="filter-item" size="small" type="primary" @click="search()"
      >搜索</el-button
    >
    <el-button class="filter-item" size="small" @click="resetQuery()"
      >重置</el-button
    >
  </div>
</template>
<script>
export default {
  name: "ButtonList",
  methods: {
    search() {
      this.$emit("search");
    },
    resetQuery() {
      this.$emit("resetQuery");
      this.search();
    },
  },
};
</script>

<style lang='scss' scoped>
.btn_list{
  padding-left: 40px;
}
</style>
